import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Spinner } from "reactstrap"
import { Doughnut } from "react-chartjs-2";
import {
    Block,
    BlockDes,
    BlockHead,
    Col,
    Row,
    PreviewAltCard,
} from "../../../components/Component";
import Head from "../../../layout/head/Head";
import OptionC from "../../components/DynmicOption/OptionC";
import DGEDashboardCount from "../DynamicComponent/DGEDashboardCount";
import ButtonDisable from "./ButtonDisable";

const DGEDashboard = ({ ...props }) => {
    const [transData, setTransData] = useState([]);
    const [activedata, setactivedata] = useState([]);
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 0,
        activeStatus: "",

    });
    if (formData.month === 0 && formData.year === 2024) {
        setFormData({ ...formData, year: 2023, month: 12 })
        //console.log("Call")
    }
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [data2, setData2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [12, 8, 7],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {
            CatgId: Number(43),

        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getstate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => { 
                    setactivedata(data)
                    setLorder(false)
                })


    };

    const getdata2 = async () => {
        /*//console.log(props)*/

        const sendData = {
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/DgeGraph', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                   /* //console.log(data)*/
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setData2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    };

    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };



    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);

   
    useEffect(() => {
        getdata()
        getdata2()
        setLorder(true)
    }, [formData.month, formData.year])






    return (<>

            <React.Fragment>
                <Head title="AllUser" />

                <Content>


                    <Block>

                        <BlockHead size="lg">

                            <BlockDes className="text-soft">

                                <Row >

                                    <Col xl="4" md="4">
                                        <td >
                                            <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                        </td>
                                    </Col>
                                    {/*  <Col xl="3" md="3">
                                        <td >
                                        <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}>{userData != null ? userData.answer1 : null}</label>Andhra Pradesh</label>
                                        </td>
                                    </Col>
                                    <Col xl="2" md="2" >

                                    <label style={{ color: 'black',  fontSize: 15 }}>  Region :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label>R1</label>
                                    </Col>*/}
                                    <Col xl="4" md="4" >
                                        <label style={{ color: 'black', fontSize: 15 }}>  Year :  <label style={{ fontWeight: 'bold' }}><OptionC  onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                                    </Col>
                                  
                                </Row>
                                <hr />
                                <Row>
                                    <Col md="4" xxl="4">
                                        <PreviewAltCard border1={true} className="h-100">
                                            <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The DGE dashboard shows the data of employment exchange of a particular month

                                            </small></h6>
                                        </PreviewAltCard>
                                    </Col>
                                    <Col md="8" xxl="8">
                                        <PreviewAltCard border1={true} className="h-100">
                                            <Row>
                                                <Col md="2"></Col>
                                                <Col md="6">
                                                    <div className="traffic-channel-group">

                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                                <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>

                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                                <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}>{Edit.submit}</large></b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>
                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                                <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}> {Edit.open}</large></b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                                <Col md="4">
                                                    <div className="traffic-channel-doughnut-ck">
                                                        <Doughnut
                                                            className="analytics-doughnut"
                                                            data={data2}
                                                            options={{
                                                                legend: {
                                                                    display: false,
                                                                },
                                                                rotation: -1.5,
                                                                cutoutPercentage: 70,
                                                                maintainAspectRatio: false,
                                                                tooltips: {
                                                                    enabled: true,
                                                                    backgroundColor: "#fff",
                                                                    borderColor: "#eff6ff",
                                                                    borderWidth: 2,
                                                                    titleFontSize: 13,
                                                                    titleFontColor: "#6783b8",
                                                                    titleMarginBottom: 6,
                                                                    bodyFontColor: "#9eaecf",
                                                                    bodyFontSize: 12,
                                                                    bodySpacing: 4,
                                                                    yPadding: 10,
                                                                    xPadding: 10,
                                                                    footerMarginTop: 0,
                                                                    displayColors: false,
                                                                },
                                                            }}
                                                        ></Doughnut>
                                                    </div>

                                                </Col>
                                            </Row>
                                        </PreviewAltCard>

                                    </Col>
                                </Row>
                            </BlockDes>


                        </BlockHead>


                        <div className="table-responsive">
                            <table className="table table-orders" ref={tableRef}>
                                <thead className="tb-odr-head">
                                    <tr className="tb-odr-item" >

                                        <th >
                                            List

                                        </th>
                                        <th >
                                            No. of EEX

                                        </th>
                                        <th >
                                            Total Forms

                                        </th>
                                        <th >
                                            Open

                                        </th>
                                        <th >
                                            Draft

                                        </th>
                                        <th >
                                            Submited

                                        </th>
                                        <th >
                                            Action

                                        </th>



                                    </tr>


                            </thead>
                            {lorder ? null :<>
                                {activedata.length !== 0 ? activedata.map((details) =>
                                        <tr>

                                            <td> <a href="#id" onClick={() => (sessionStorage.setItem("State", details.catgTypeId), window.location.pathname = "/State-Dashboard")} ><b style={{ fontSize: 18 }}>{details.catgType}</b>
                                            </a></td>

                                        <DGEDashboardCount year={formData.year} month={formData.month} catgtype={details.catgTypeId} api={'Dgecount'} />
                                        <ButtonDisable year={formData.year} month={formData.month} catgtype={details.catgTypeId} api={'Dgecount'} />
                                            </tr>
                                ) : <Spinner color="success" />
                                }</>
                            }




                            </table>

                        </div>




                    </Block>




                </Content>

            </React.Fragment>
    </>
    );
};

export default DGEDashboard;
